import { combineReducers } from 'redux';

import toasts from 'modules/messageSystem/reducers/toasts';

import remoteMedia from './remoteMedia';
import internetMeter from './internetMeter';
import connectionStatus from './connectionStatus';
import consultationInfo from './consultationInfo';
import consultationStats from './consultationStats';
import consultationParams from './consultationParams';
import currentConversation from './currentConversation';
import consultationLifecycle from './consultationLifecycle';


export default combineReducers({
  toasts: toasts('video'),

  remoteMedia,
  internetMeter,
  connectionStatus,
  consultationInfo,
  consultationStats,
  consultationParams,
  currentConversation,
  consultationLifecycle,
});
